const getImageUrl = imageField => {
	return imageField ? `https:${imageField.fields?.file.url}` : null
}

export default getImageUrl
